import { useQuery } from '@tanstack/react-query';
import { api, publicApi } from './client';

export interface LinkedInspector {
  id: string;
  displayName: string;
}

export interface Me {
  subject: string;
  username: string;
  displayName: string;
  email?: string;
  roles: string[];
  admin: boolean;
  inspector?: LinkedInspector | null;
  preferredLanguage?: string | null;
}

export interface AppInfo {
  name: string;
  version: string;
}

export function useMe() {
  return useQuery({ queryKey: ['me'], queryFn: () => api<Me>('/me'), staleTime: 5 * 60 * 1000 });
}

export function useAppInfo() {
  return useQuery({ queryKey: ['info'], queryFn: () => publicApi<AppInfo>('/info'), staleTime: Infinity });
}

export function useIsAdmin(): boolean {
  return useMe().data?.admin ?? false;
}
